import { useCreateManualFormModal } from '~/components/Modals/ManualFormModal';
import { useAppNavigation } from '~/hooks/nav.hook';
import { translate } from '~/utils/translation.utils';

export const usePurchaseByCRCInputModal = () => {
  const navigation = useAppNavigation();
  return useCreateManualFormModal({
    title: translate('purchases.purchasesForCRC'),
    subtitle: translate('purchases.enterCRC'),
    formData: [
      {
        items: [
          {
            type: 'text',
            label: translate('purchases.companyReservationCode'),
            id: 'companyReservationCode',
          },
        ],
      },
    ],
    onConfirm: (value) => {
      navigation.navigate('PurchasesByCRC', value);
    },
  });
};
